import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  gap: 32px;
  background-color: #fcfcfc;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 24px 16px;
    gap: 24px;
    justify-content: flex-start;
  }
`;

export const MainLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 24px;
    max-width: 800px;
  }
`;

export const ActionsPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 280px;

  @media (max-width: 1024px) {
    flex-direction: row;
    max-width: 100%;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: var(--black);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const CertificateContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 900px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background-color: var(--white);
  padding: 12px;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  overflow: hidden;

  /* Ensures child respects container width while keeping the aspect ratio */
  aspect-ratio: 1.414 / 1;

  /* Animated Thin Glow Border Effect */
  &::before {
    content: "";
    position: absolute;
    width: 200%;
    height: 200%;
    top: -50%;
    left: -50%;
    z-index: 1;
    background: conic-gradient(
      from 0deg,
      transparent 0%,
      rgba(152, 53, 209, 0.1) 60%,
      rgba(152, 53, 209, 1) 80%,
      transparent 100%
    );
    animation: rotateGlow 4s linear infinite;
    pointer-events: none;
  }

  @keyframes rotateGlow {
    100% {
      transform: rotate(360deg);
    }
  }

  /* Máscara interna para furar o meio do container e mostrar apenas a borda (1px) */
  &::after {
    content: "";
    position: absolute;
    inset: 1px; /* Espessura da borda animada */
    background: var(--white);
    border-radius: 11px; /* Ligeiramente menor que o container */
    z-index: 1;
  }

  &:hover {
    box-shadow: 0px 12px 40px rgba(152, 53, 209, 0.08);
  }

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

export const CertificateWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 1.414 / 1; /* A4 Landscape Ratio */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  overflow: hidden;
  background-color: white;
  z-index: 2;

  @media (max-width: 768px) {
    border-radius: 2px;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  pointer-events: none;
`;

export const OverlayContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

export const ParticipantName = styled.h2`
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: clamp(16px, 3.5vw, 42px);
  font-weight: 700;
  color: var(--fixit);
  text-align: center;
  width: 80%;
  margin: 0;
  white-space: nowrap;
  font-family: inherit;
`;

export const CourseName = styled.p`
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: clamp(12px, 2.2vw, 24px);
  font-weight: 600;
  color: var(--fixit);
  text-align: center;
  width: 80%;
  margin: 0;
`;

export const DateText = styled.span`
  position: absolute;
  top: 61%;
  left: 56.5%;
  transform: translate(0, -50%);
  font-size: clamp(8px, 1.2vw, 16px);
  color: var(--fixit);
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
`;

export const DurationText = styled.span`
  position: absolute;
  top: 65%;
  left: 55.5%;
  transform: translate(0, -50%);
  font-size: clamp(8px, 1.2vw, 16px);
  color: var(--fixit);
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: var(--fixit);
  color: var(--white);
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 15px rgba(152, 53, 209, 0.3);
  width: 100%;

  svg {
    font-size: 24px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 6px 20px rgba(152, 53, 209, 0.4);
  }

  &:disabled {
    background-color: var(--gray);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: transparent;
  color: var(--fixit);
  border: 1px solid var(--fixit);
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  svg {
    font-size: 24px;
  }

  &:hover {
    background-color: rgba(152, 53, 209, 0.05);
  }
`;
